import React from "react";
// import "../../styles/chilirojo/_vip.scss";

const VipChart = (props) => {
  const tiers = [
    { name: 'Rookie', wagers: '$0', monthly: '.015% of amount wagered - profit/ loss', levelUp: 'None', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: false, bonusGrowth: false, vipHost: false, bespoke: false },
    { name: 'Associate I Bronze', wagers: '$10,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$100', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: false, vipHost: false, bespoke: false },
    { name: 'Associate II Silver', wagers: '$25,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$250', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.002% to all bonuses', vipHost: false, bespoke: false },
    { name: 'Associate III Gold', wagers: '$100,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$500', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.005% to all bonuses', vipHost: false, bespoke: false },
    { name: 'Soldier I - III Platinum I - III', wagers: '$250,000\n$500,000\n$1M', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$1,000', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.007% to all bonuses', vipHost: true, bespoke: false },
    { name: 'Caporegime I - III Platinum IV - VI', wagers: '$2.5M\n$5M\n$10M', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$2,500', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.01% to all bonuses', vipHost: true, bespoke: true },
    { name: 'Underboss Diamond', wagers: '$25,000,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$5,000', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.012% to all bonuses', vipHost: true, bespoke: true },
    { name: 'Consigliere', wagers: '$50,000,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$10,000', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.015% to all bonuses', vipHost: true, bespoke: true },
    { name: 'Don', wagers: '$100,000,000', monthly: '.015% of amount wagered - profit/ loss', levelUp: '$25,000', rakeback: '.02% of amount wagered', weekly: '.01% of amount wagered - profit/ loss', daily: true, bonusGrowth: '0.02% to all bonuses', vipHost: true, bespoke: true },
  ];

  // Helper component to render a check or cross icon
  const CheckCrossIcon = ({ isIncluded }) => (
    <div className={`vipChart__icon ${isIncluded ? 'vipChart__icon--check' : 'vipChart__icon--cross'}`}></div>
  );

  return (
    <div className="vipChart">
      <div className="vipChart__container">
        <h1 className="vipChart__title">VIP Loyalty Chart</h1>

        {/* Desktop View (Table) */}
        <div className="vipChart__tableWrap">
          <table className="vipChart__table">
            <thead>
              <tr>
                <th className="vipChart__th vipChart__th--spacer"></th>
                {tiers.map((tier, index) => (
                  <th key={index} className="vipChart__th vipChart__th--tier">{tier.name}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* Wager Amount Row */}
              <tr className="vipChart__row">
                <td className="vipChart__label">Wager Amount</td>
                {tiers.map((tier, index) => (
                  <td key={index} className="vipChart__cell vipChart__cell--wagers"><span className="vipChart__multiline">{tier.wagers}</span></td>
                ))}
              </tr>
              {/* Other rows */}
              {['Monthly Bonuses', 'Level Up Bonuses', 'Rakeback', 'Weekly Bonuses', 'Daily Bonuses / Reload', 'Bonus Growth', 'Dedicated VIP Host', 'Bespoke Bonuses'].map((benefit, benefitIndex) => (
                <tr key={benefitIndex} className="vipChart__row">
                  <td className="vipChart__label">{benefit}</td>
                  {tiers.map((tier, tierIndex) => {
                    let value;
                    switch (benefit) {
                      case 'Monthly Bonuses': value = tier.monthly; break;
                      case 'Level Up Bonuses': value = tier.levelUp; break;
                      case 'Rakeback': value = tier.rakeback; break;
                      case 'Weekly Bonuses': value = tier.weekly; break;
                      case 'Daily Bonuses / Reload': value = <CheckCrossIcon isIncluded={tier.daily} />; break;
                      case 'Bonus Growth': value = tier.bonusGrowth ? tier.bonusGrowth : <CheckCrossIcon isIncluded={false} />; break;
                      case 'Dedicated VIP Host': value = <CheckCrossIcon isIncluded={tier.vipHost} />; break;
                      case 'Bespoke Bonuses': value = <CheckCrossIcon isIncluded={tier.bespoke} />; break;
                      default: value = '';
                    }
                    return (
                      <td key={tierIndex} className="vipChart__cell">{value}</td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile & Tablet View (Cards) */}
        <div className="vipChart__cards">
          {tiers.map((tier, index) => (
            <div key={index} className="vipChart__card">
              <h2 className="vipChart__cardTitle">{tier.name}</h2>
              <div className="vipChart__cardBody">
                <div className="vipChart__cardRow"><div>Wager Amount</div><div className="vipChart__multiline">{tier.wagers}</div></div>
                <div className="vipChart__cardRow"><div>Monthly Bonuses</div><div>{tier.monthly}</div></div>
                <div className="vipChart__cardRow"><div>Level Up Bonuses</div><div>{tier.levelUp}</div></div>
                <div className="vipChart__cardRow"><div>Rakeback</div><div>{tier.rakeback}</div></div>
                <div className="vipChart__cardRow"><div>Weekly Bonuses</div><div>{tier.weekly}</div></div>
                <div className="vipChart__cardRow"><div>Daily Bonuses / Reload</div><CheckCrossIcon isIncluded={tier.daily} /></div>
                <div className="vipChart__cardRow"><div>Bonus Growth</div>{tier.bonusGrowth ? <div>{tier.bonusGrowth}</div> : <CheckCrossIcon isIncluded={false} />}</div>
                <div className="vipChart__cardRow"><div>Dedicated VIP Host</div><CheckCrossIcon isIncluded={tier.vipHost} /></div>
                <div className="vipChart__cardRow"><div>Bespoke Bonuses</div><CheckCrossIcon isIncluded={tier.bespoke} /></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VipChart;
